import { isPresent } from '@jjvgaming/player-payback-library'
import { useApiQuery } from 'hooks/useApiQuery'
import { minimumSearchLength } from 'utils/util'

export const useGetContestLicensedEstablishmentSearch = (
  contestId: number,
  searchKey: string
) => {
  return useApiQuery({
    enabled: isPresent(searchKey) && searchKey.length >= minimumSearchLength,
    method: 'get',
    path: '/admin/contests/{contestId}/licensed-establishments/search',
    queryKey: [
      '/admin/contests/{contestId}/licensed-establishments/search',
      contestId,
      searchKey,
    ],
    queryArgs: {
      contestId,
      searchKey,
    },
  })
}
